import { render, staticRenderFns } from "./SubheaderListItem.vue?vue&type=template&id=6fd3e5b8&scoped=true&"
import script from "./SubheaderListItem.vue?vue&type=script&lang=js&"
export * from "./SubheaderListItem.vue?vue&type=script&lang=js&"
import style0 from "./SubheaderListItem.vue?vue&type=style&index=0&id=6fd3e5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd3e5b8",
  null
  
)

export default component.exports